import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import { closeModal } from '@stores/modals';
import { IGameRequest } from '@interfaces/IGameRequest';
import { useStore } from 'effector-react';
import gamesRequest, { reject } from '@stores/gamesRequest/gamesRequest';
import GameRequestModalPreview from '@pages/GamesPage/GameRequestModal/GameRequestModalPreview';
import useTranslate from '@hooks/useTranslate';
import componentContent from '../GamesPage.module.json';
import css from '@pages/GamesPage/GameRequestModal/GameRequestModalPreview.module.less';

interface GameRequestModalRejectProps {
  games: IGameRequest[];
}

const GameRequestModalReject: FunctionComponent<GameRequestModalRejectProps> = ({
  games: data,
}) => {
  const {
    preloaders: { reject: preloaders },
  } = useStore(gamesRequest);
  const content = useTranslate(componentContent);
  const [games, setGames] = useState(data);

  useEffect(() => {
    setGames(data);
  }, [data]);

  const handleReject = useCallback(() => {
    reject({ suggestIds: games.map((game) => game.id) });
  }, [games]);

  const handleDeleteGame = useCallback((id) => {
    setGames((oldGames) => {
      return oldGames.filter((game) => game.id !== id);
    });
  }, []);

  return (
    <Modal
      title={content.title_reject}
      onCancel={() => closeModal({ name: 'gameRequest' })}
      visible
      onOk={handleReject}
      okText={content.reject}
      confirmLoading={!!preloaders}
    >
      <Spin spinning={!!preloaders}>
        <div className={css.preview}>
          <GameRequestModalPreview games={games} deleteGame={handleDeleteGame} />
        </div>
      </Spin>
    </Modal>
  );
};

export default GameRequestModalReject;
